module.exports = __webpack_public_path__ + "img/wxproject.cdf1ce3e.jpg";